import React from "react";
function TermsConditions(){
    return(
        <>
        <section className="breadcrumb-main pb-15 pt-15 bookingHeaderSection" >
            <div className="section-shape section-shape1 top-inherit bottom-0" ></div>
            <div className="breadcrumb-outer">
                <div className="container">
                    <div className="breadcrumb-content text-center">
                        <h1 className="mb-3">Terms & Conditions</h1>
                    </div>
                </div>
            </div>
        </section>
        <section className="trending pt-6 pb-0 bg-lgrey">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-xs-12 mb-4">

                        
						<p><strong>Effective Date:</strong> [Insert Date]</p>
						<p>These terms and conditions govern the relationship between the customer and <strong>The Holiday Experts</strong>, a travel agency. By accessing or using our services, including making bookings through our website, you agree to be bound by these Terms. If you do not agree with these Terms, please do not use our services.</p>

						<hr />
						<h3>1. About Us</h3>
						<p>At <strong>The Holiday Experts</strong>, we are dedicated to making your travel dreams a reality. Whether you're looking for flights, hotels, or bespoke travel packages, we strive to provide unmatched value and personalized services tailored to your needs. Our experienced team partners with top airlines, hotels, and travel providers to ensure you enjoy seamless and memorable journeys.</p>

						<hr />
						<h3>2. Booking Process</h3>
						<p>When you book a service through us, you acknowledge that:</p>
						<ul className="list">
							<li>You are fully responsible for providing accurate and complete information during the booking process.</li>
							<li>For all services, we require a non-refundable deposit at the time of booking. The remaining balance must be paid as per the payment schedule outlined in the booking agreement.</li>
						</ul>

						<hr />
						<h3>3. Payments and Fees</h3>
						<ul className="list">
							<li><strong>Payment Methods:</strong> We accept payments through credit or debit cards and bank transfer.</li>
							<li><strong>Booking Deposits:</strong> For all services, a deposit is required at the time of booking. The full balance must be paid before the travel service is provided, unless otherwise specified.</li>
							<li><strong>Non-Refundable Fees:</strong> Please note that initial deposit, booking fees, and cancellation fees are non-refundable.</li>
							<li><strong>Currency and Charges:</strong> All charges are payable in the currency specified at the time of booking, and additional charges may apply based on the selected service or payment method (e.g., currency conversion fees, transaction fees).</li>
						</ul>

						<hr />
						<h3>4. Cancellations and Amendments</h3>
						<ul className="list">
							<li><strong>Cancellations:</strong> If you need to cancel a booking, you must notify us in writing. Cancellation terms vary by airlines or suppliers and are subject to their specific policies, which will be communicated to you as per your request.</li>
							<li><strong>Amendments:</strong> Any amendments to your booking (e.g., changes to travel dates, destinations, etc.) are subject to availability and may incur additional charges.</li>
							<li><strong>Refunds:</strong> In the event of a cancellation or change, refunds will be processed in accordance with the supplier’s policy. Please note that some services, such as special offers or discounted packages, are non-refundable.</li>
						</ul>

						<hr />
						<h3>5. Travel Documents</h3>
						<ul className="list">
							<li><strong>Passport and Visa:</strong> You must ensure your passport is valid for at least 6 months beyond your travel date, and you have obtained any necessary visas for your destination.</li>
							<li><strong>Travel Insurance:</strong> We strongly recommend that you purchase comprehensive travel insurance to cover potential issues like cancellations, delays, medical emergencies, and lost luggage.</li>
						</ul>

						<hr />
						<h3>6. Liability and Limitation of Liability</h3>
						<ul className="list">
							<li><strong>Travel Services Providers:</strong> We act as an intermediary between you and service providers such as airlines, hotels, and car hire companies. We are not responsible for the actions or failures of these suppliers.</li>
							<li><strong>Liability:</strong> To the extent permitted by law, <strong>The Holiday Experts</strong> will not be liable for any indirect, incidental, or consequential damages, including but not limited to travel delays, cancellations, accidents, personal injury, or loss of property.</li>
							<li><strong>Force Majeure:</strong> We are not responsible for delays, cancellations, or failure to deliver services caused by circumstances beyond our control, including natural disasters, political instability, or strikes.</li>
						</ul>

						<hr />
						<h3>7. Travel Insurance</h3>
						<p>We strongly recommend that you purchase comprehensive travel insurance to protect against unforeseen events such as trip cancellations, lost luggage, medical emergencies, and accidents during your travels. We can help you find suitable travel insurance policies, but it is ultimately your responsibility to choose the right level of coverage for your needs.</p>

						<hr />
						<h3>8. Website Use and Intellectual Property</h3>
						<ul className="list">
							<li><strong>Website Access:</strong> You agree to use our website and services for lawful purposes only. Any misuse of our website, including attempts to interfere with its proper functioning, is prohibited.</li>
							<li><strong>Intellectual Property:</strong> All content on the <strong>The Holiday Experts</strong> website, including text, graphics, logos, and images, is protected by copyright and other intellectual property laws. You may not reproduce or distribute any content without prior written consent.</li>
						</ul>

						<hr />

						<h3>9. Privacy and Data Protection</h3>
						<p>We take your privacy seriously and are committed to protecting your personal data. Please refer to our Privacy Policy for information on how we collect, use, and protect your personal information.</p>

						<hr />

						<h3>10. Amendments to Terms and Conditions</h3>
						<p>We may update or amend these Terms and Conditions from time to time. Any changes will be posted on our website, and the revised version will be effective immediately upon posting. It is your responsibility to review these Terms regularly to stay informed of any updates.</p>

						<hr />

						<h3>11. Contact Us</h3>
						<p>If you have any questions or concerns regarding these Terms and Conditions, please contact us at:</p>
						<p><strong>The Holiday Experts</strong></p>
						<p>Email: [Insert Email Address]</p>
						<p>Phone: [Insert Phone Number]</p>
						<p>Address: [Insert Company Address]</p>
	
                    </div>
                </div>
            </div>
        </section>         
        </>
    )
}
export default TermsConditions;